export const TEST_ID = 'loadingBar';
